export const getOppositeValue = (value?: number): number | undefined => {
	return value !== undefined ? -value : value;
};
